{
  "sections": [
    {
      "id": "visualization-builder",
      "label": "Visualization Builder",
      "icon": "auto_graph",
      "description": "Create datasets and dashboards.",
      "source": "static",
      "layout": "list",
      "items": [
        {
          "label": "Data Builder",
          "description": "Prepare source files and build data pipelines.",
          "icon": "storage",
          "path": "/generate-visualization?view=data",
          "accent": "#1769e0"
        },
  
        {
          "label": "DVM Layout Builder",
          "description": "Build advanced reusable dashboard layouts.",
          "icon": "view_quilt",
          "path": "/generate-visualization?view=layout",
          "accent": "#d97706"
        },
        {
          "label": "Design Builder",
          "description": "Design a screen on a free canvas with layers and prebuilt components.",
          "icon": "design_services",
          "path": "/generate-visualization?view=design",
          "accent": "#7c3aed"
        },
        {
          "label": "Kaveri Generation",
          "description": "Build your microservices",
          "icon": "build",
          "path": "/generate-visualization?view=generate",
          "accent": "#d97706"
        }
      ]
    },
    {
      "id": "dashboards",
      "label": "Dashboards",
      "icon": "space_dashboard",
      "description": "",
      "source": "menuGroup",
      "groupName": "Dashboards",
      "layout": "list"
    }
  ]
}
